import { useEffect, useRef } from 'react'
import Typed from 'typed.js'

import Avatar from 'common/components/Avatar'
import Emoji from 'common/emoji'
import { useAppSelector } from 'common/hooks/redux'

import { useGetDailyWelcomeMessage } from '../api/queries/useGetDailyWelcomeQuery'

const DEFAULT_MESSAGE = 'Hey, welcome back to Phrasee!'
const DEFAULT_EMOJI = '👋'

const WelcomeMessage = () => {
  const typedMessageElement = useRef<HTMLDivElement | null>(null)
  const typedMessageElementHidden = useRef<HTMLDivElement | null>(null)

  const {
    profile: { avatarColor },
    firstName,
    lastName,
    accountId,
  } = useAppSelector((state) => state.authStates)

  const { data: payload, isLoading } = useGetDailyWelcomeMessage(
    accountId,
    firstName
  )

  const welcome_message = payload?.data?.dailyMessage?.text ?? DEFAULT_MESSAGE
  const emoji_symbol = payload?.data?.dailyMessage?.emoji ?? DEFAULT_EMOJI
  useEffect(() => {
    const height = typedMessageElementHidden.current?.clientHeight
    typedMessageElement.current?.setAttribute('style', `height: ${height}px;`)

    if (!isLoading) {
      const typed = new Typed(typedMessageElement.current, {
        strings: [welcome_message],
        showCursor: false,
        typeSpeed: 50,
      })

      return () => {
        typed.destroy()
      }
    }
  }, [welcome_message, isLoading])

  return (
    <div
      data-cy="welcome-message-container"
      className="flex flex-end gap-6 self-stretch text-3xl"
    >
      <div className="self-stretch items-center relative">
        <Avatar
          color={avatarColor}
          firstName={firstName}
          lastName={lastName}
          className="w-14 h-14 mt-2 text-2xl font-medium"
        />
        <div className="text-shadow absolute left-11 top-0 ">
          {!isLoading && <Emoji symbol={emoji_symbol} />}
        </div>
      </div>
      <div className="flex-col pl-3 color-coolGray-800 font-medium w-100 gap-1 relative h-full">
        <div className="invisible absolute" ref={typedMessageElementHidden}>
          {welcome_message}
        </div>
        <div className="" ref={typedMessageElement} />
      </div>
    </div>
  )
}

export default WelcomeMessage
